<!--
  @description 新开机申请单
  @author xiehan
  @date 2019/01/14
-->
<template>
  <div class="bootUpOrder">
    <request-note
      ref="requestNote"
      @submitRequest="getRequestForm"
      submitButtonRac="bootUpOrder@submit"
      :requestTitle="$t('cloudApplication.bootUpRequest')"
      :assignee="assignee"
      :status="status"
      :requestInfo="requestInfo">
      <div slot="center">
        <el-table
          :data="tableData"
          style="width: 100%">
          <el-table-column prop="hostType" :label="$t('cloudApplication.models')"></el-table-column>
          <el-table-column prop="count" :label="$t('cloudApplication.num')"></el-table-column>
          <el-table-column prop="disk" :label="$t('cloudApplication.disk')"></el-table-column>
          <el-table-column prop="networSegment" :label="$t('cloudApplication.network')"></el-table-column>
        </el-table>
      </div>
      <div slot="footer">
        <i class="separation-line" v-if="assignee && status === '3'"></i>
        <div v-if="assignee && status === '3'">
          <el-row :gutter="10" style="margin-bottom: 10px;">
            <el-col :span="4">
              <div v-text="$t('cloudApplication.models')"></div>
            </el-col>
            <el-col :span="8">
              <div v-text="'IP'"></div>
            </el-col>
          </el-row>
          <el-form :model="hostListForm" label-width="0">
            <el-row :gutter="10" v-for="(item, index) in hostListForm.hostList" :key="item.hostType + index">
              <el-col :span="4">
                <span v-text="item.hostType" class="bootup-title"></span>
              </el-col>
              <el-col :span="8">
                <el-form-item>
                  <el-input v-model="item.ip"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <el-form label-width="80px" v-if="!assignee && (status !== '6' && status !== '5')">
          <el-form-item :label="$t('cloudApplication.currentAssignee')">
            <span v-text="requestInfo.currentAssignee"></span>
          </el-form-item>
        </el-form>
        <el-table
          v-if="status === '6'"
          :data="ipTable"
          style="width: 100%; margin-bottom: 20px;">
          <el-table-column prop="hostType" :label="$t('cloudApplication.models')"></el-table-column>
          <el-table-column prop="ip" label="IP"></el-table-column>
        </el-table>
        <el-table
          v-if="!assignee"
          :data="processTable"
          style="width: 100%">
          <el-table-column prop="operateTime" :label="$t('common.time')"></el-table-column>
          <el-table-column prop="node" :label="$t('queryworkOrder.node')"></el-table-column>
          <el-table-column prop="operator" :label="$t('queryworkOrder.operator')"></el-table-column>
          <el-table-column prop="operation" :label="$t('common.handle')"></el-table-column>
          <el-table-column prop="advise" :label="$t('queryworkOrder.advise')"></el-table-column>
        </el-table>
      </div>
    </request-note>
  </div>
</template>

<script>
  import dic from '@/components/mixins/dic'
  import requestNote from '@/views/component/requestNote/requestNote'
  import queryworkOrderBiz from '@/logic/workFlow/queryworkOrderBiz'
  import TimeFormat from '@/utils/timeFormat'
  export default {
    mixins: [dic],
    data () {
      return {
        status: '',
        select_hostType: {},
        select_site: {},
        select_operate: {},
        requestInfo: {},
        tableData: [],
        assignee: true,
        processTable: [],
        hostListForm: {
          hostList: []
        },
        ipTable: []
      }
    },
    components: {
      requestNote
    },
    methods: {
      init () {
        this.status = String(this.$route.query.status)
        this.assignee = String(this.$route.query.assignee) === '1'
        this.getDic()
      },
      getOrderInfoById () {
        queryworkOrderBiz.getTaskDetailById({
          processInstanceId: String(this.$route.query.orderId)
        }).then(data => {
          this.requestInfo = data.info
          this.requestInfo.site = this.select_site[this.requestInfo.site]
          this.requestInfo.date = TimeFormat.getFormatTime(this.requestInfo.date)
          this.requestInfo.expectedTime = TimeFormat.getFormatTime(this.requestInfo.expectedTime)
          this.tableData = this.requestInfo.hostInfoList
          this.tableData.map(item => {
            item.hostType = this.select_hostType[item.hostType]
          })
          this.processTable = data.record
          this.processTable.map(item => {
            item.operateTime = TimeFormat.getFormatTime(item.operateTime)
            item.operation = this.select_operate[item.operation]
          })
          this.hostListForm.hostList = []
          this.tableData.map(item => {
            for (let i = 0; i < item.count; i++) {
              this.hostListForm.hostList.push({
                hostType: item.hostType,
                ip: ''
              })
            }
          })
          this.ipTable = []
          if (this.requestInfo.hostAllocatedList) {
            this.requestInfo.hostAllocatedList.map(item => {
              this.ipTable.push(item)
            })
          }
        })
      },
      async getDic () {
        await Promise.all([
          this.dGetDictionaryByCode('hosttype2'),
          this.dGetDictionaryByCode('remoteconfig'),
          this.dGetDictionaryByCode('workflowOperationType')
        ])
        this.select_hostType = { ...this.dDictionary.hosttype2 }
        this.select_site = { ...this.dDictionary.remoteconfig }
        this.select_operate = { ...this.dDictionary.workflowOperationType }
        this.getOrderInfoById()
      },
      getRequestForm (val) {
        let eventName
        let param = {}
        if (this.$route.query.status === '2') {
          eventName = 'approveApply'
          param = { ...val }
        } else if (this.$route.query.status === '3') {
          eventName = 'execute'
          param.hostAllocatedList = []
          this.hostListForm.hostList.map(item => {
            param.hostAllocatedList.push({
              hostType: Object.keys(this.select_hostType).filter(_item => this.select_hostType[_item] === item.hostType)[0],
              ip: item.ip
            })
          })
          if (param.hostAllocatedList.every(item => item.ip === '')) {
            this.$message({
              message: this.$t('queryworkOrder.ipTips'),
              type: 'warning'
            })
            return
          }
        }
        queryworkOrderBiz[eventName]({
          processInstanceId: this.$route.query.orderId, ...param
        }).then(data => {
          this.$message({
            message: this.$t('common.success'),
            type: 'success'
          })
          this.$router.push({ name: 'queryworkOrder' })
        })
      }
    },
    watch: {
      $route (to, from) {
        if (to.name === 'bootUpOrder' && from.name === 'queryworkOrder') {
          if (this.status === '5') {
            this.$nextTick(() => {
              this.$refs.requestNote.onStatus5()
            })
          } else {
            this.$refs.requestNote.init()
          }
          this.init()
        }
      }
    },
    mounted () {
      this.init()
      if (this.status === '5') {
        this.$nextTick(() => {
          this.$refs.requestNote.onStatus5()
        })
      }
    }
  }
</script>

<style scoped>
  .bootup-title {
    height: 36px;
    line-height: 36px;
    display: inline-block;
  }
  .separation-line {
    display: block;
    height: 1px;
    background: #eee;
    margin: 20px 0;
  }
</style>